import React, {PropTypes} from 'react';
import DisplayIf from 'shared/DisplayIf.jsx';

const AccountCreated = ({
  addressBase,
  onResendEmailClick,
  displayGoHome
}) => (
  <div>
    <h2>
    Please Confirm Your Email
    </h2>
    <p>
    We've created your account. To protect your private information, we need to confirm your email address.
    </p>
    <p>
    Please check your email for a link to confirm your email address and enable your account.
    </p>
    <br/>
    <p>
    Can’t find your verification email?
    </p> 
    <button 
      type="button"
      className="btn btn-secondary"
      onClick={onResendEmailClick}> 
      Resend email
    </button>
    
    <DisplayIf condition={displayGoHome} 
               className="animated fadeIn">
      <br/>
      <br/>
      <p>
      Already verified your email?
      </p> 
      <a href={`${addressBase}/registration`}>
        <button 
          type="button"
          className="btn btn-secondary"> 
          Home
        </button>
      </a>
    </DisplayIf>
  </div>
);

AccountCreated.propTypes = { 
  addressBase: PropTypes.string,
  onResendEmailClick: PropTypes.func.isRequired,
  displayGoHome: PropTypes.bool.isRequired
};

AccountCreated.defaultProps = { 
};

export default AccountCreated;



// WEBPACK FOOTER //
// ./src/features/registration/accountCreated/AccountCreated.jsx